﻿import { Action, ActionErrorCanceled, Controller, Model, ViewHandlebars as View, Router, StoreJsonApi, StoreErrorDataEmpty, Util } from '@dwightbcoder/action-ui/src/index.js'
import * as Controllers from '../controller/index.js'
import * as Components from '../component/index.js'
import Config from './config.js'

// #region Configuration
View.options.basePath = '/Plugins/Apex.UI/Content/view/'

// App object for export
let App = {
	Ready: false,
	ReadyI18n: false,
	Action: Action,
	Model: Model,
	View: View,
	Router: Router,
	Util: Util,
	Component: Components,
	Modal: {},
	Config: new Model(
	{
		customerId: 0,
		languageId: 0,
		storeId: 0,
		cookieNameBrowserWarning: 'browser-warning',
		cookieNamePrivacyAlerted: 'privacy-alerted',
		useDismissableAlerts: true
	}),
	Roles: {
		Administrator: 'Administrators',
		Guest: 'Guests',
		Practitioner: 'Practitioner',
		Patient: 'Patient',
		Registered: 'Registered',
		ForumModerator: "ForumModerators",
		ManageProduct: "ManageProducts",
		ManageCustomer: "Manage Customers",
		ManageOrder: "Manage Orders",
		ManageStore: "Manage Stores",
		Marketing: "Marketing",
		CST: "CST"
	},
	Store: new StoreJsonApi({
		baseUrl: '/api/v1',
		defaultPageSize: 20,
		types: [
			'address',
			'addressremote',
			'auth',
			'cart',
			'cartitem',
			'category',
			'config',
			'contact',
			'checkout',
			'country',
			'coupon',
			'customercatalog',
			'customer',
			'i18n',
			'message',
			'month',
			'order',
			'ordersummary',
			'paymentmethod',
			'product',
			'promotion',
			'recaptchasettings',
			'register',
			'registerhcp',
			'route',
			'reorder',
			'savedcart',
			//'searchresult',
			'shippingoption',
			'state',
			'stateprovince',
			'storecustomer',
			'storeproduct',
			'topic',
			'walletcard',
		],
		fetch: { mode: 'cors' },
		verbose: Config.verbose,
		viewClass: View, //ViewHandlebars
		viewMap: {
			'address': ['grid/address', 'grid/addressSelect', 'partial/component/dropdownAddressOptions'],
			'cartitem': ['cart/form', 'cart/menu', 'cart/summary'],
			'checkout': ['checkout/summary', 'checkout/discount', 'partial/checkout/shippingOptions'],
			'coupon': 'grid/coupon',
			'customer': ['layout/headerMyAccount', 'layout/headerNavUser'],
			'customercatalog': 'grid/customercatalog',
			'invoice': 'grid/invoice',
			'message': 'grid/message',
			'ordersummary': 'grid/ordersummary',
			'payment': 'grid/payment',
			'product': 'grid/product',
			'reorder': 'grid/reorder',
			'return': 'grid/return',
			'savedcart': 'grid/savedcart',
			//'searchresult': 'partial/component/dropdownSearchProductItems',
			'shippingoption': 'partial/component/dropdownShippingMethodOptions',
			'storecustomer': 'grid/storecustomer',
			'storeproduct': 'grid/storeproduct',
			'storestep': ['store/accountSetup', 'partial/storeSetup/Title', 'partial/storeSetup/Summary'],
			'walletcard': ['grid/walletcard', 'grid/walletCardSelect', 'partial/component/dropdownPaymentMethodOptions'],
		},
		actionHandler: {
			'delete': function (type, method, resolve, reject, data)
			{
				if (data.confirm == '0')
					return this.delete(type, data.id)
						.then(json => resolve(json))
						.catch(json => reject(json))

				App.UI.Confirm(
					Helper.i18n('common.deleteconfirmation'),
					(result) => !result ? resolve(new ActionErrorCanceled('Canceled')) : this.delete(type, data.id)
						.then(json => resolve(json))
						.catch(json => reject(json))
				)
			}
		}
	}),
	cssClass: {
		loading: 'is-loading',
		invalid: 'invalid',
		fail: 'fail',
		success: 'success'
	},
	UI: {
		Confirm: (message, callback, options = {}) => bootbox.confirm(Util.deepCopy({ size: 'small', message, callback }, options)),
		AlertError: (message, callback, options) => bootbox.dialog(Util.deepCopy({ message: '<div class="alert alert-danger mb-0"><b>' + message + '</b></div>', callback }, options)),
		Alert: (message, callback, options) => bootbox.alert(Util.deepCopy({ size: 'small', message, callback }, options))[0],
	},
	Usage: {
		I18n: {}
	}
}

// Set BulmaJS options
window.bulmaOptions = { autoParseDocument: false }

Action.options = { verbose: Config.verbose, cssClass: App.cssClass }
View.options = { verbose: Config.verbose, cssClass: App.cssClass }

// Layout views
View.create({ model: App.Config, name: 'layout/topBanner' })
View.create({ model: App.Config, name: 'layout/topBannerAboutHCP' })
View.create({ model: App.Config, name: 'layout/headerNav' })
View.create({ name: 'layout/footer' })

Router.options = {
	interceptLinks: false,
	verbose: Config.verbose,
	view: new View('controller'),
	controllers: Controllers,
	cssClass: App.cssClass
}

export { App, Action, ActionErrorCanceled, Controller, Controllers, Model, View, Router, StoreErrorDataEmpty, Util }
